import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

export const useTrialCheck = () => {
  const { tenantData } = useAuth();
  const [isTrialExpired, setIsTrialExpired] = useState(false);
  const [trialDaysRemaining, setTrialDaysRemaining] = useState<number | null>(null);

  useEffect(() => {
    if (!tenantData?.subscription) {
      setIsTrialExpired(false);
      setTrialDaysRemaining(null);
      return;
    }

    const subscription = tenantData.subscription;
    
    // Check if it's a trial subscription
    if (subscription.status === 'trial' && subscription.endDate) {
      let endDate: Date;
      
      // Handle both Firestore Timestamp and regular Date objects
      if (subscription.endDate.seconds) {
        // Firestore Timestamp
        endDate = new Date(subscription.endDate.seconds * 1000);
      } else if (subscription.endDate.toDate) {
        // Firestore Timestamp with toDate method
        endDate = subscription.endDate.toDate();
      } else {
        // Regular Date object
        endDate = new Date(subscription.endDate);
      }
      
      const now = new Date();
      const diffTime = endDate.getTime() - now.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      
      setTrialDaysRemaining(Math.max(0, diffDays));
      setIsTrialExpired(diffDays <= 0);
    } else {
      setIsTrialExpired(false);
      setTrialDaysRemaining(null);
    }
  }, [tenantData?.subscription]);

  const isTrialActive = tenantData?.subscription?.status === 'trial' && !isTrialExpired;
  const hasActiveSubscription = tenantData?.subscription?.status === 'active';
  const hasFreeWorkspace =
    tenantData?.workspacePlan === 'free' ||
    (!tenantData?.workspacePlan && !tenantData?.subscription && Boolean(tenantData?.id));
  const canAccessApp = hasFreeWorkspace || hasActiveSubscription || isTrialActive;

  return {
    isTrialExpired,
    isTrialActive,
    hasActiveSubscription,
    hasFreeWorkspace,
    canAccessApp,
    trialDaysRemaining,
    subscription: tenantData?.subscription
  };
}; 